import { createAction, handleActions } from 'redux-actions';

// state

const initialState = {
  isAlertOpen: false,
  isLoading: false,
  trace: {
    type: 'info',
    message: '',
  },
};

// actions

export const CHANGE_PASSWORD_STARTED = 'userDetails/editUserPassword/CHANGE_PASSWORD_STARTED';
export const CHANGE_PASSWORD_FAILED = 'userDetails/editUserPassword/CHANGE_PASSWORD_FAILED';
export const CHANGE_PASSWORD_SUCCEEDED = 'userDetails/editUserPassword/CHANGE_PASSWORD_SUCCEEDED';
export const CHANGE_PASSWORD_FINALLY = 'userDetails/editUserPassword/CHANGE_PASSWORD_FINALLY';

export const HIDE_ALERT = 'userDetails/editUserPassword/HIDE_ALERT';

// action creators

export const changePassword = createAction(CHANGE_PASSWORD_STARTED);
export const changePasswordFailed = createAction(CHANGE_PASSWORD_FAILED);
export const changePasswordSucceeded = createAction(CHANGE_PASSWORD_SUCCEEDED);
export const changePasswordFinally = createAction(CHANGE_PASSWORD_FINALLY);
export const hideAlert = createAction(HIDE_ALERT);

// reducers

const handleChangePassword = state => ({
  ...state,
  isLoading: true,
});

const handleChangePasswordFailed = (state, { payload }) => ({
  ...state,
  isAlertOpen: true,
  isLoading: false,
  trace: {
    status: 'error',
    message: t(payload),
  },
});

const handleChangePasswordSucceeded = state => ({
  ...state,
  isAlertOpen: true,
  isLoading: false,
  trace: {
    status: 'info',
    message: t('user.password_change.success'),
  },
});

const handleChangePasswordFinally = state => ({
  ...state,
  isLoading: false,
});

const handleHideAlert = state => ({
  ...state,
  isAlertOpen: false,
});

export default handleActions(
  {
    [CHANGE_PASSWORD_STARTED]: handleChangePassword,
    [CHANGE_PASSWORD_SUCCEEDED]: handleChangePasswordSucceeded,
    [CHANGE_PASSWORD_FINALLY]: handleChangePasswordFinally,
    [CHANGE_PASSWORD_FAILED]: handleChangePasswordFailed,
    [HIDE_ALERT]: handleHideAlert,
  },
  initialState,
);

// selectors

export const getTrace = state => state.userDetails.editUserPassword.trace;

export const getIsAlertOpen = state => state.userDetails.editUserPassword.isAlertOpen;

export const getIsLoading = state => state.userDetails.editUserPassword.isLoading;
